module.exports = __webpack_public_path__ + "img/view-icon.41dac148.svg";